import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentUserResponse {
  message: string;
  id: string;
};

// 请求接口
interface AgentUsersUpdateRequest {
  agentId: string;
  userId: string;

  basicUserName: string;
  gender: string;
  roleStatus: number;

  avatar: string;
  agentUserName: string;
  personalTitle: string;
  introduction: string;

  videoSubscribe: number;
  articleSubscribe: number;
  blogSubscribe: number;
  momentsSubscribe: number;
  graphicSubscribe: number;
  aiSubscribe: number;
  chatSubscribe: number;
}


export class AgentUserUpdateData {
  id: string | number;
}

const transformAndValidateAgent = (
  response: AgentUserResponse
): AgentUserUpdateData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentUserUpdateData);
  } catch (error) {
    console.error("Agent User data validation failed:", error.message);
    throw error;
  }
};

/** 保存用户信息(上半部份)*/
export const agentV2UsersUpdateAll = async (params: AgentUsersUpdateRequest): Promise<AgentUserUpdateData> => {
  const response = await api.post<AgentUserResponse>('/agent-v2/users/update-all', {
    agent_id: params.agentId,
    user_id: params.userId,
    basic_user_name: params.basicUserName,
    gender: params.gender,
    role_status: params.roleStatus,

    avatar: params.avatar,
    agent_user_name: params.agentUserName,
    personal_title: params.personalTitle,
    introduction: params.introduction,

    ai_subscribe: params.aiSubscribe,
    video_subscribe: params.videoSubscribe,
    article_subscribe: params.articleSubscribe,
    blog_subscribe: params.blogSubscribe,
    moments_subscribe: params.momentsSubscribe,
    graphic_subscribe: params.graphicSubscribe,
    chat_subscribe: params.chatSubscribe,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
